import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Account } from '../models/account';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { catchError, map } from 'rxjs/operators';
import * as auth from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) { }

  public checkUserNameExists(emailAddress: string): Observable<boolean> {
    let url = `${environment.baseApiUrl}/accounts/checkusername/${emailAddress}`;
    return this.httpClient.get<boolean>(url)
      .pipe(map(res => { return res; }),
            catchError(error => {
            console.log(`Error when checking username availability. ${error["error"]}`);
            return of(false);
        })
      );
  }

  public createAccount(account: Account): Observable<any> {
    let url = `${environment.baseApiUrl}/accounts`;
    return this.httpClient.post(url, account);
  }
}
